import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'

import reducerAuth from './reducers/reducerAuth'
import reducerCallAPI from './reducers/reducerCallAPI'
import reducerDisplay from './reducers/reducerDisplay'

export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    authen: reducerAuth.authen,

    errorList: reducerCallAPI.errorList,

    allDisplay: reducerDisplay.allDisplay,
    display: reducerDisplay.display

})


// WEBPACK FOOTER //
// ./src/app/redux/reducers.js